// src/Star.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Star_default = createIcon({
  displayName: "Star",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.9427 18.8477L16.9117 21.8468C17.6957 22.3197 18.6627 21.6168 18.4547 20.7257L17.1357 15.0728L21.5267 11.2688C22.2187 10.6698 21.8487 9.53275 20.9367 9.45575L15.1567 8.96575L12.8957 3.63075C12.5387 2.78975 11.3467 2.78975 10.9897 3.63075L8.72874 8.96575L2.94874 9.45575C2.03674 9.53275 1.66674 10.6698 2.35874 11.2688L6.74974 15.0728L5.43074 20.7257C5.22274 21.6168 6.18974 22.3197 6.97374 21.8468L11.9427 18.8477Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  Star_default
};
